var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    fill: "black",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.11913H11.9893C11.9184 5.64736 11.5113 5.28564 11.0198 5.28564H8.9806C8.48907 5.28564 8.08203 5.64736 8.01114 6.11913H6C5.44772 6.11913 5 6.56685 5 7.11913V13.4525C5 14.0047 5.44772 14.4525 6 14.4525H14C14.5523 14.4525 15 14.0047 15 13.4525V7.11913C15 6.56684 14.5523 6.11913 14 6.11913ZM10 12.7857C11.3807 12.7857 12.5 11.6664 12.5 10.2857C12.5 8.90495 11.3807 7.78567 10 7.78567C8.61932 7.78567 7.50003 8.90495 7.50003 10.2857C7.50003 11.6664 8.61932 12.7857 10 12.7857ZM9.99976 11.9525C10.9202 11.9525 11.6664 11.2063 11.6664 10.2858C11.6664 9.36536 10.9202 8.61916 9.99976 8.61916C9.07929 8.61916 8.3331 9.36536 8.3331 10.2858C8.3331 11.2063 9.07929 11.9525 9.99976 11.9525Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a10067669fd38088317e0e7c51abc1f7.svg";
export { ForwardRef as ReactComponent };